export default __webpack_public_path__ + "static/media/screenshare.b36bbb17.png";